import { createDecorator } from '../../instantiation/common/instantiation.js';
const ICommandService = ( createDecorator('commandService'));
export { ICommandService };
